export default __webpack_public_path__ + "static/media/O-145.ff8ad008.png";